const gtmSelector = state => state.gtm;
export const gtmDataSelector = state => gtmSelector(state).data || {};
const gtmPageViewsSelector = state => gtmSelector(state).pageViews;
export const gtmLastPageViewSelector = state =>
  gtmPageViewsSelector(state).last;
export const gtmWaitingPageViewSelector = state =>
  gtmPageViewsSelector(state).waiting;
